import { useState } from 'react'
import type { Project } from '../data/projectTypes'
import { useGetSecuritySetupQuery, useUpdateProjectMutation } from '../services/projectDataApi'
import { SecurityNonceSetup } from './chat/SecurityNonceChatCard'
import './chat/chat.css'
import './TestingSetup.css'
import './SetupPage.css'

export default function ProjectSecuritySetup({ project, canEdit, verified }: { project: Project; canEdit: boolean; verified: boolean }) {
  const setup = useGetSecuritySetupQuery(project.id, { skip: !canEdit || !!project.security_nonce || project.security_ownership_exempt === true })
  const [update] = useUpdateProjectMutation()
  const [error, setError] = useState('')
  const nonce = project.security_nonce || setup.currentData?.nonce
  const exempt = project.security_ownership_exempt === true
  return <section className="setup-section testing-settings" aria-label="Security setup">
    <div className="setup-section__header">
      <div>
        <h2>Confirm you own this app</h2>
        <p>QA only runs security probes against apps you control.</p>
      </div>
    </div>
    <div className="setup-section__body">
    {!canEdit && <p>A project member can configure security testing for this app.</p>}
    {setup.isLoading && <p role="status">Preparing ownership instructions…</p>}
    {setup.isError && <p role="alert">Could not prepare ownership instructions. <button onClick={() => void setup.refetch()}>Retry</button></p>}
    {exempt ? <p role="status">Ownership is already approved for this project. No ownership file is needed.</p>
      : nonce && <SecurityNonceSetup key={nonce} projectId={project.id} targetUrl={project.target_url ?? ''} nonce={nonce} verified={verified}
          onResult={async state => {
            if (!state.verified || project.security_probing_enabled || !project.enabled_polish_passes.includes('security')) return
            setError('')
            try { await update({ id: project.id, data: { security_probing_enabled: true } }).unwrap() }
            catch { setError('Ownership confirmed, but pentesting could not start. Check again to retry.') }
          }} />}
    {error && <p role="alert">{error}</p>}
    </div>
  </section>
}
